import * as React from "react";
const SvgFiRrFeeReceipt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M10.1 6.6v1.801h1.101a.8.8 0 1 1 0 1.6H10.1v2.2a.8.8 0 1 1-1.6 0v-6.4a.8.8 0 0 1 .8-.8h1.9a.8.8 0 1 1 0 1.6zm5.601 0a.8.8 0 1 0 0-1.6h-1.9a.8.8 0 0 0-.8.8v6.4a.8.8 0 0 0 .8.8h1.9a.8.8 0 1 0 0-1.6H14.6V10h1.101a.8.8 0 1 0 0-1.6H14.6V6.599zm4.5 3.4a.8.8 0 1 0 0-1.6H19.1V6.599h1.101a.8.8 0 1 0 0-1.6h-1.9a.8.8 0 0 0-.8.8v6.4a.8.8 0 0 0 .8.8h1.9a.8.8 0 1 0 0-1.6H19.1v-1.4h1.101zm-.2 5a1 1 0 0 0-1 1v5.103l-1.1-.753a1 1 0 0 0-1.13 0l-2.101 1.438-2.1-1.439a1 1 0 0 0-1.13 0l-2.1 1.439-2.106-1.438a1 1 0 0 0-1.129 0L5 21.106V5c0-1.654 1.346-3 3-3h8.356c.732 0 1.436.266 1.983.75a1 1 0 1 0 1.325-1.499 5 5 0 0 0-3.308-1.25H7.998a5.004 5.004 0 0 0-5 4.999v18a1 1 0 0 0 1.564.825l2.105-1.439 2.106 1.439a1 1 0 0 0 1.129 0l2.101-1.439 2.1 1.439c.341.232.79.232 1.13 0l2.101-1.438 2.1 1.438A1.001 1.001 0 0 0 20.999 23v-6.999a1 1 0 0 0-1-1z"
    />
  </svg>
);
export default SvgFiRrFeeReceipt;
